import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { PilotPayAccessToken } from '../types/auth.type';
import { IdentityService } from '../identity/services/identity.service';

/**
 * RoleGuard
 */
@Injectable()
export class RoleGuard implements CanActivate {
	constructor(private identityService: IdentityService, private router: Router) {}

	public canActivate(): boolean {
		const accessToken:PilotPayAccessToken = this.identityService.accessToken.getValue();

		if(accessToken.payload.userData?.isAdmin) {
			return true;
		}

		this.router.navigate(['./pilotpay/dashboard']).then();

		return false

	}
}
